import { render } from "./role-own-scope.vue?vue&type=template&id=48f08c24"
import script from "./role-own-scope.vue?vue&type=script&lang=js"
export * from "./role-own-scope.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dereklei/Documents/DotnetProjects/WorkProjects/OAuth.Server.OneId/OAuth.Server/Web/Saas.Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__